// Shared PWA install controller.
//
// The browser fires `beforeinstallprompt` exactly once and often *before* any
// React component mounts, so we capture it at module load and expose a tiny
// pub/sub API. Both the auto InstallPrompt dialog and the manual "Install app"
// button in Settings consume this single source of truth.

let deferredPrompt = null;
const subs = new Set();

function emit() {
  subs.forEach((cb) => { try { cb(); } catch (e) { /* ignore */ } });
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    emit();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    emit();
  });
}

export function canInstall() {
  return !!deferredPrompt;
}

export function subscribeInstall(cb) {
  subs.add(cb);
  return () => subs.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return 'unavailable';
  deferredPrompt.prompt();
  let outcome = 'dismissed';
  try {
    const res = await deferredPrompt.userChoice;
    outcome = res?.outcome || 'dismissed';
  } catch (e) { /* ignore */ }
  deferredPrompt = null;
  emit();
  return outcome;
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export function isIOS() {
  if (typeof window === 'undefined') return false;
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}
